import { api } from "./client";
import type { MatchUser } from "./matches";

export interface Review {
  id: number;
  reviewer: MatchUser;
  reviewee_id: number;
  trade_proposal_id: number | null;
  stars: number;
  text: string | null;
  created_at: string;
}

export async function createReview(payload: { trade_proposal_id: number; stars: number; text?: string }): Promise<Review> {
  return api<Review>("/reviews", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function fetchUserReviews(userId: number, limit = 20): Promise<Review[]> {
  return api<Review[]>(`/reviews/users/${userId}?limit=${limit}`);
}

export async function fetchMyReviewForTrade(tradeId: number): Promise<Review | null> {
  return api<Review | null>(`/reviews/trade/${tradeId}/mine`);
}
